import React from 'react';
import PropTypes from 'prop-types';
import Terms from 'components/terms/Terms';

class ProRouter extends React.Component {
  static propTypes = {
    children: PropTypes.object,
    location: PropTypes.object,
  };

  render() {
    return this.props.children || <Terms {...this.props} />;
  }
}

export default ProRouter;
